var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdviceNotIncluded = function SvgAdviceNotIncluded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.81 8.062a.5.5 0 0 1 0 .707l-7.125 7.124a.5.5 0 1 1-.707-.707l7.124-7.124a.5.5 0 0 1 .707 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.81 15.893a.5.5 0 0 1-.708 0L7.978 8.77a.5.5 0 1 1 .707-.707l7.124 7.124a.5.5 0 0 1 0 .707Z"
  }))));
};
export { SvgAdviceNotIncluded as ReactComponent };
export default __webpack_public_path__ + "6b462c29e32b861e67ba2e0f64964aba.svg";